import api from '../../apiConfig/apiConfig';
import { Get, Post, Patch } from '../base/baseAjax';

let addUpdate = (params) => {
  return Post({
    url: api.setting.addUpdate,
    bodyParam: params,
  });
};

let functionDetail = (params) => {
  return Get({
    url: api.setting.functionDetail,
    PathParam: params,
  });
};

let updateStatus = (params) => {
  return Post({
    url: api.setting.updateStatus,
    bodyParam: params,
  });
};

export default {
  addUpdate,
  functionDetail,
  updateStatus,
};
